module.exports = __webpack_public_path__ + "img/fang-year1.b7dd82d9.png";